import React, { useEffect, useState } from "react";
import Link from "next/link";
import Footer from "../../components/_App/Footer";
import Navbar from "../../components/_App/Navbar1";
import PageBanner from "../../components/Common/PageBanner";
import CurrentAffairsCategories from "../../components/Blog/CurrentAffairsCategories";
import Head from "next/head";

//allCategories

const OfferingView = ({ offering, dataNav }) => {
  const [tabUrl, setTabUrl] = useState(null);
  const [seotitle, setSeoTitle] = useState(null);
  const [images, setImages] = useState(null);
  const [seoDescription, setSeoDescription] = useState(null);
  useEffect(() => {
    setTabUrl(window.location.href);
    setSeoTitle(offering && offering[1].name);
    setImages(offering[1].image);
    setSeoDescription(
      offering[0].description.slice(0, 170).replace(/(<([^>]+)>)/gi, "")
    );
  }, []);
  // console.log("this is all category view", allCategories);

  // useEffect(() => {
  //   const scrollWin = () => {
  //     window.scrollTo({ top: 600, left: 0, behavior: "smooth" });
  //   };
  //   scrollWin();
  // }, []);
  // console.log("offering:", offering);

  return (
    <>
      <Navbar data={dataNav} />
      <PageBanner
        pageTitle="ToppersNotes Current Affairs"
        homePageUrl="/"
        homePageText="Home"
        activePageText="Current Affairs"
      />

      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          <title>{seotitle}</title>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta property="og:title" content={seotitle} />
          <meta name="description" content={seoDescription} />
          <meta
            property="og:description"
            content={seoDescription}
            key="description"
          />
          <meta property="og:image" content={images} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <link
            rel="canonical"
            property="og:title"
            content={seotitle}
            key="title"
            href={tabUrl}
          ></link>
        </Head>
      </div>

      <div className="container">
        <div className="row my-8">
          {offering && offering
            ? offering.map((offer) => (
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <div className="single-categories-box">
                    <img src={offer.image} className=" h-48" alt="image" />

                    <div className="content">
                      <h6 className="text-xl text-white font-bold mb-2">
                        {offer.name}
                      </h6>
                      <span className="text-xs">
                        {offer && offer.resources_count ? (
                          <>{offer.resources_count} Resoures</>
                        ) : offer.articles_count ? (
                          <>{offer.articles_count} Aricles</>
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                    {/* <Link href={`/blog/months`}>
                    <a className="link-btn"></a>
                  </Link> */}
                    {/* < href={ offer && offer.type === "static"? `./offerings/${offer.slug}`: `./offerings/offering/`}> */}

                    <Link
                      href={
                        offer && offer.type === "static" ? (
                          `/current-affairs/${offer.slug}`
                        ) : offer.type === "dynamic" &&
                          offer.view === "detailed" ? (
                          `/current-affairs/english-current-affair`
                        ) : offer.type === "dynamic" &&
                          offer.view === "simple" ? (
                          `/current-affairs/articles/${offer.slug}`
                        ) : (
                          <a href="#"></a>
                        )
                      }
                    >
                      <a className="link-btn"></a>
                    </Link>
                    {/* <Link href={`/categories/${categories.slug}`}>
                    <a className="link-btn"></a>
                  </Link> */}
                  </div>
                </div>
              ))
            : "Loading"}
        </div>
      </div>
      <br />
      <CurrentAffairsCategories />
      <Footer />
    </>
  );
};

export default OfferingView;

export async function getStaticProps() {
  const res = await fetch("https://api.toppersnotes.com/api/ca/get-offerings");

  const offering = await res.json();
  // console.log("this is all category view", offering);

  if (!offering) {
    return {
      notFound: true,
    };
  }

  return {
    props: { offering },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 86400, // In seconds
  };
}
